import React from 'react';
import {
    ModalBody,
    SubscriptionRewardPopup,
    VoucherDiv,
    VoucherHeading,
    SubscriptionRewardImg,
    VoucherIcon,
    VoucherDescription,
    Footer,
    HeaderSection,
    HeaderDescription,
} from './SubscriptionRewardModal.styled';
import { RewardModalProps } from './types';
import PromoLayoutIcon from '../Icons/PromoLayoutIcon';

export default function SubscriptionRewardModal(props: Readonly<RewardModalProps>) {
    const {
        show = false,
        close = () => {},

        learnMoreConfig = {
            tagLine: '',
            cardOneDescription: '',
            cardOneVoucherAmount: '',
            cardTwoDescription: '',
            cardTwoVoucherAmount: '',
            header: '',
            loyaltyLogoWhite: '',
            loyaltyBanner: '',
            learnMore: '',
            learnMoreLink: '',
        },
    } = props;
    return (
        <SubscriptionRewardPopup
            variant="default"
            additionalProps={{ className: 'modalPopup' }}
            open={show}
            handleClose={close}
            header={{
                isCloseIcon: true,
                show: show,
                children: (
                    <HeaderSection>
                        {learnMoreConfig.loyaltyBanner && (
                            <SubscriptionRewardImg>
                                <img
                                    height={'330px'}
                                    width={'690px'}
                                    src={learnMoreConfig.loyaltyBanner}
                                    alt={learnMoreConfig.header ?? 'Loyalty banner'}
                                />
                            </SubscriptionRewardImg>
                        )}
                        {learnMoreConfig.loyaltyLogoWhite && (
                            <HeaderDescription>
                                <span>{learnMoreConfig.header}</span>
                                <img
                                    height={'38.88px'}
                                    width={'360px'}
                                    src={learnMoreConfig.loyaltyLogoWhite}
                                    alt={learnMoreConfig.header ?? 'Loyalty logo'}
                                />
                            </HeaderDescription>
                        )}
                    </HeaderSection>
                ),
            }}
            body={{
                show: show,
                children: (
                    <ModalBody>
                        {learnMoreConfig.tagLine && <VoucherHeading>{learnMoreConfig.tagLine}</VoucherHeading>}
                        <VoucherDiv>
                            {learnMoreConfig.cardOneVoucherAmount && (
                                <VoucherIcon>
                                    <PromoLayoutIcon />
                                    {learnMoreConfig.cardOneVoucherAmount}
                                </VoucherIcon>
                            )}
                            {learnMoreConfig.cardOneDescription && (
                                <VoucherDescription>{learnMoreConfig.cardOneDescription}</VoucherDescription>
                            )}
                        </VoucherDiv>
                        <VoucherDiv>
                            {learnMoreConfig.cardTwoVoucherAmount && (
                                <VoucherIcon>
                                    <PromoLayoutIcon />
                                    {learnMoreConfig.cardTwoVoucherAmount}
                                </VoucherIcon>
                            )}
                            {learnMoreConfig.cardTwoDescription && (
                                <VoucherDescription>{learnMoreConfig.cardTwoDescription}</VoucherDescription>
                            )}
                        </VoucherDiv>
                    </ModalBody>
                ),
            }}
            footer={{
                children: (
                    <Footer>
                        {learnMoreConfig.learnMore && (
                            <a href={learnMoreConfig.learnMoreLink} target="_blank" rel="noreferrer">
                                {learnMoreConfig.learnMore}
                            </a>
                        )}
                    </Footer>
                ),
                show: show,
            }}
        />
    );
}
